import React, { useEffect } from 'react';
import { generateNavURL } from '../../../utils/generateNavURL';

const PrimaryNavMobile = ({ portalUri, apiNavigationTop }) => {
    useEffect(() => {
        const script = document.createElement('script');

        script.src = '/assets/js/2018/submenu.js'; // Ensures that menu + submenu will expand and collapse
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [apiNavigationTop]);

    const menuLinksDektop = apiNavigationTop?.data ?? [];
    const numberOfMenuItems = 3;
    const menuLinks = menuLinksDektop.slice(0, numberOfMenuItems);

    const generateURL = (url) => generateNavURL(url, portalUri);

    const getSubnavClass = (index) => {
        if (index === 0) {
            return 'subnav-left';
        } else if (index === numberOfMenuItems - 1) {
            return 'subnav-right';
        }
        return 'subnav-center';
    };

    return (
        <div className='flex around nav-container'>
            {menuLinks.map((navigation, levelOneKey) => (
                <React.Fragment key={`top-nav-item-${levelOneKey}`}>
                    {navigation?.children?.length ? (
                        <React.Fragment>
                            <button className='nav-button'>
                                {navigation?.name}{' '}
                                <i
                                    className='fas fa-caret-down'
                                    role='img'
                                    aria-hidden='true'
                                    aria-label='Caret pointing down to signify expandable content'></i>
                            </button>
                            <div className={`subnav-mobile ${getSubnavClass(levelOneKey)}`}>
                                <ul className='subnav-mobile-level-1'>
                                    {navigation?.children?.map((submenuL1, levelTwoKey) => (
                                        <React.Fragment key={`top-nav-item-${levelOneKey}-${levelTwoKey}`}>
                                            {submenuL1?.children?.length ? (
                                                <li>
                                                    <button className='subnav-mobile-btn'>
                                                        {submenuL1?.name}{' '}
                                                        <i
                                                            className='fa fa-caret-down'
                                                            role='img'
                                                            aria-hidden='true'
                                                            aria-label='Caret pointing down to signify expandable content'>
                                                            &nbsp;
                                                        </i>
                                                    </button>
                                                    <ul className='subnav-mobile-level-2'>
                                                        {submenuL1?.children?.map((submenuL2, levelThreeKey) => (
                                                            <li key={`top-nav-item-${levelOneKey}-${levelTwoKey}-${levelThreeKey}`}>
                                                                <a href={generateURL(submenuL2?.get_url)} className='subnav-mobile-level-2-link'>{submenuL2?.name}</a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </li>
                                            ) : (
                                                <li>
                                                    <a href={generateURL(submenuL1?.get_url)} role='menuitem' tabIndex='-1'>
                                                        {submenuL1?.name}
                                                    </a>
                                                </li>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </ul>
                            </div>
                        </React.Fragment>
                    ) : (
                        <button>
                            <a role='menuitem' tabIndex='-1' href={generateURL(navigation?.get_url)} {...(navigation?.open_new ? `target="_blank"` : ``)}>
                                {navigation?.name}
                            </a>
                        </button>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default PrimaryNavMobile;
